// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CrossRateCache } from "./CrossRateCache.js"

export let CrossratesPlan = function (id, dCache)
{
    this.DCache = dCache

    this.Id = id                                        // long
    this.Name = null                                    // string
    this.Description = null                             // string
    this.CounterAccountID = null                        // int

    this.nonTradableCrossRates = new MarkupValue()
    this.markupCache = {}                               // Dictionary<int, MarkupValue>
}

CrossratesPlan.prototype.Update = function (message)
{
    this.Name = message.Name
    this.Description = message.Description
    this.CounterAccountID = message.CounterAccountID

    this.FillNonTradableMarkups(message)
    this.FillMarkups(message)
}

CrossratesPlan.prototype.GetNonTradableMarkup = function (exp1, exp2, crossprice)                 // non-tradable markup
{
    let res = this.nonTradableCrossRates.CrossRates[exp1 + CrossRateCache.CROSS_DELIMITER + exp2] || 0
    return crossprice * res / 100
}

CrossratesPlan.prototype.GetMarkup = function (exp1, exp2, crossprice, tradeInstrument, forBuy)      // markup for pnl calc         
{
    let result = { 'markup': 0, 'formula': MarkupFormula.None },
        value = null
    if (tradeInstrument)
    {
        let markUpByType = this.markupCache[tradeInstrument.TypeId]
        value = markUpByType ? markUpByType : this.markupCache[-1]                                  // дефолтовый если неопределенно для конкретного типа инструмента
    }

    let res = value ? value.CrossRates[exp1 + CrossRateCache.CROSS_DELIMITER + exp2] : null
    if (res)
    {
        result.markup = (forBuy ? 1 : -1) * (crossprice * res / 100)
        result.formula = value.Formula
    }
    
    return result
}

CrossratesPlan.prototype.FillNonTradableMarkups = function (message)
{
    var table = this.ParseDatas(message.NonTradableMarkups)
    this.nonTradableCrossRates = new MarkupValue(table)
}

CrossratesPlan.prototype.FillMarkups = function (message)
{
    let dCache = this.DCache
    message.MarkupData.sort(function (x, y)     //сортируем от общих групп - к конкретным, для корректной перезаписи
    {
        let xt = x.TypeId, yt = y.TypeId

        if (xt == yt)
            return 0                            //планы равносильны

        if (xt == -1)                           //дефолтовый - самый первый
            return -1
        if (yt == -1)
            return 1

        if (dCache)
        {
            var list = []                       //все типы, для которых x - родительский
            dCache.FindInstrumentTypes(xt, list)

            if (list.includes(yt))              //если x стоит выше в иерархии, чем y
                return -1

            list = []                           //наоборот
            dCache.FindInstrumentTypes(yt, list)
            if (list.includes(xt))
                return 1
        }

        return xt - yt                          //  <- типы равносильны. чтобы была определенность
    });

    let copy = {} // Dictionary < int, MarkupValue > copy = new Dictionary < int, MarkupValue > ();
    for (let markup of message.MarkupData)
    {
        let formula = markup.Formula,
            prices = this.ParseDatas(markup.Markups),
            markupValue = new MarkupValue(prices, formula)

        if (markup.TypeId == -1)
            copy[markup.TypeId] = markupValue
        else
        {
            let list = []
            dCache.FindInstrumentTypes(markup.TypeId, list)
            for (let subtype of list)
                copy[subtype] = markupValue
        }
    }

    this.markupCache = copy
}

CrossratesPlan.prototype.ParseDatas = function (datas)                  // private static Dictionary<string, double> ParseDatas(CrossRateData[] datas)
{
    var table = {}                                                      // new Dictionary < string, double> ();
    for (let data of datas)
    {
        if (data.Price == 0)
            continue

        table[data.Exp1 + CrossRateCache.CROSS_DELIMITER + data.Exp2] = table[data.Exp2 + CrossRateCache.CROSS_DELIMITER + data.Exp1] = data.Price
    }
    return table
}

// #region MarkupValue
export let MarkupValue = function (crossRates, formula)
{
    this.CrossRates = crossRates || {}
    this.Formula = !isNaN(formula) && formula !== null ? formula : MarkupFormula.None
}
// #endregion MarkupValue

export let MarkupFormula = { None: -1, OpenAndClose: 0, Pnl: 1, MarginOpenAndClose: 2 }